import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
// import Service
import { LoadingService } from '../../service/loading.service';
import { GlobalService } from '../../service/global.service';
import { PurchaseService } from '../../service/purchase.service';

// 表格過濾排序使用套件
import {DecimalPipe} from '@angular/common';
import {Observable} from 'rxjs';
import {NgbdSortableHeader, SortEvent} from '../../directive/sortable.directive';

// Interface
import {BillHeader} from '../../interface/billheader';
// 建立表單控制套件
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
// 稅別選擇
import TaxStateObj from '../../config/taxState.json';
import PriceOfTaxObj from '../../config/priceoftax.json';
import CurrencyObj from '../../config/currency.json';
// 備註編輯器
import { AngularEditorConfig } from '@kolkov/angular-editor';


@Component({
	selector: 'app-purchase',
	templateUrl: './purchase.component.html',
	styleUrls: ['./purchase.component.css'],
	providers: [PurchaseService, DecimalPipe]
})
export class PurchaseComponent implements OnInit {

	purchases$: Observable<BillHeader[]>;
	total$: Observable<number>;
	// 判斷目前成員頁面的狀態
	IsBrowsing: boolean = true;
	IsCreate: boolean = false;
	IsDetail: boolean = false;
	IsEdit: boolean = false;
	provider$: any = [];
	activeProvider$: any = [];
	products$: any = [];
	activeProducts$: any = [];

	categories$: any = [];
	taxstates$: any = [];
	pricetax$: any = [];
	currency$: any = [];
	succdiscs$: any = [];

	// 預設使用者權限為最低
	userPower = 103;

	_year = new Date().getFullYear();
	_month = ('0' + (new Date().getMonth() + 1)).slice(-2);

	// 新增使用的 form
	purchaseForm = new FormGroup({
		ERPCompID: new FormControl(''), // 隱藏參數
		BillDate: new FormControl(''),
		PlanDate: new FormControl(''),
		AccDate: new FormControl({ year: this._year, month: this._month }),
		Memo: new FormControl('<p><br /></p>'),
		BillCode: new FormControl(''),
		BillType: new FormControl(2),
		BillProviderID: new FormControl(''),
		BillProviderName: new FormControl(''),
		BillProviderCode: new FormControl(''),
		BillProviderAddress: new FormControl(''),
		BillProviderPhoneNum: new FormControl(''),
		BillProviderFaxNum: new FormControl(''),
		DeliverCityCode: new FormControl(0),
		DeliverCityName: new FormControl(''),
		DeliverZipCode: new FormControl(''),
		DeliverZipName: new FormControl(''),
		DeliverAddress: new FormControl(''),
		CurrencyCode: new FormControl('1'),
		PriceOfTax: new FormControl(1), // 控制產品單價裡面有沒有含稅, 預設含稅
		Total: new FormControl(0),
		TaxFee: new FormControl(0),
		TaxState: new FormControl('1'), // 1: 免稅, 2: 應稅, 3: 零稅
		PurchaseItems: new FormArray([this.purchaseBodyForm(1, '')]),
		DiscID: new FormControl(null),
		SubjTagID: new FormControl(null),
		CusTagID: new FormControl(null),
		ReceiverArray: new FormControl(null),
		ReceiverNameArray: new FormControl(null)
	});
	// 詳細內容的 form
	detailForm = new FormGroup({
		ERPCompID: new FormControl(''), // 隱藏參數
		BillState: new FormControl(0), 
		BillDate: new FormControl(''),
		PlanDate: new FormControl(''),
		AccDate: new FormControl(''),
		Memo: new FormControl(''),
		BillCode: new FormControl(''),
		BillType: new FormControl(2),
		BillProviderID: new FormControl(''),
		BillProviderName: new FormControl(''),
		BillProviderCode: new FormControl(''),
		BillProviderAddress: new FormControl(''),
		BillProviderPhoneNum: new FormControl(''),
		BillProviderFaxNum: new FormControl(''),
		CurrencyCode: new FormControl('1'),
		PriceOfTax: new FormControl(1), // 控制產品單價裡面有沒有含稅
		PriceOfTaxStr: new FormControl(''), // 產品單價裡面有沒有含稅字串值
		Total: new FormControl(0),
		TaxFee: new FormControl(0),
		TaxState: new FormControl('1'), // 1: 應稅, 2: 免稅, 3: 零稅
		TaxStateStr: new FormControl(''),
		PurchaseItems: new FormArray([]),
		SubjID: new FormControl('')
	});

	editorConfig: AngularEditorConfig = {
	    editable: true,
	      height: 'auto',
	      minHeight: '50',
	      maxHeight: '200',
	      width: 'auto',
	      minWidth: '0',
	      enableToolbar: false,
	      showToolbar: false,
	      placeholder: 'Enter memo here...',
	      defaultParagraphSeparator: 'p',
	      defaultFontName: '',
	      defaultFontSize: '12',
	      fonts: [
	        {class: 'arial', name: 'Arial'},
	        {class: 'times-new-roman', name: 'Times New Roman'},
	        {class: 'calibri', name: 'Calibri'},
	        {class: 'comic-sans-ms', name: 'Comic Sans MS'}
	      ],
	      customClasses: [
	      {
	        name: 'quote',
	        class: 'quote',
	      },
	      {
	        name: 'redText',
	        class: 'redText'
	      },
	      {
	        name: 'titleText',
	        class: 'titleText',
	        tag: 'h1',
	      },
	    ],
	    uploadUrl: 'v1/image',
	    sanitize: false,
	    toolbarPosition: 'top'
	};

	@ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

	constructor(
		private router: Router,
		private loadingService: LoadingService,
		private globalService: GlobalService,
		public purchaseService: PurchaseService
	) {
		this.purchases$ = purchaseService.purchases$;
		this.total$ = purchaseService.total$;

		this.taxstates$ = TaxStateObj.TaxStates;
		this.pricetax$ = PriceOfTaxObj.PriceOfTax;
		this.currency$ = CurrencyObj.Currency;
	}

	ngOnInit() {
		this.loadingService.startLoading("權限確認中...");
		let _currentERPComp = JSON.parse(localStorage.getItem('currentERPComp'));
		let _currentERPUser = JSON.parse(localStorage.getItem('currentERPUser'));
		// 取得使用者權限
		if (_currentERPComp != null && _currentERPUser != null) {
			this.globalService.getUserPowerID(_currentERPComp.ERPCompID, _currentERPUser.ERPUserID).subscribe(response => {
				if (response.result) {
					this.userPower = response.MemberInfo['Power'];
					console.log(this.userPower);
				}
				this.loadingService.stopLoading();
			});
		}
		this.loadingService.stopLoading();
		this.loadingService.startLoading('讀取採購單據資料...');
		let _currentCompInfo = JSON.parse(localStorage.getItem('currentERPComp'));
		if (_currentCompInfo != null) {
			let _erpCompid = _currentCompInfo.ERPCompID;
			// 取得供應商列表資料
			this.purchaseService.getSupplierList(_erpCompid).subscribe(response => {
				if (response.IsSuccess) {
					console.log(response);
					this.provider$ = response.SupplierList;
				}
			});
			// 取得產品列表
			this.purchaseService.getProductItemsList(_erpCompid).subscribe(response => {
				if (response.IsSuccess) {
					console.log(response.ItemsList);
					this.products$ = response.ItemsList;
				}
			});
			// 取得啟用中供應商列表資料
			this.purchaseService.getActiveSupplierList(_erpCompid).subscribe(response => {
				if (response.IsSuccess) {
					this.activeProvider$ = response.SupplierList;
				}
			});
			// 取得啟用中產品列表
			this.purchaseService.getActiveProductItemsList(_erpCompid).subscribe(response => {
				if (response.IsSuccess) {
					this.activeProducts$ = response.ItemsList;
				}
			});
		}
		else {
			this.failHttpRequest('open', 1, '未授權狀態!');
			this.router.navigate(['/login']);
		}
		// 取得Succmail發送討論組列表資料
		let _currentUserInfo = JSON.parse(localStorage.getItem('currentERPUser'));
		let _token = localStorage.getItem('Token');
		if (_currentUserInfo != null && _token != null && _currentCompInfo != null) {
			this.purchaseService.getSuccDiscList(_currentCompInfo['SuccCompID'], _currentUserInfo['SuccUserID'], _token).subscribe(response => {
				let _activeDiscs = response.data.filter(res => { if(res.discussion_info) {return res.discussion_info['IsActive'] == 1 && res.discussion_info['DiscType'] == 2;} })
												.map(function(obj) { 
													return obj.discussion_info;
												});
				this.succdiscs$ = _activeDiscs;
				console.log(this.succdiscs$);
				this.loadingService.stopLoading();
			});
		}
		else {
			this.failHttpRequest('open', 1, '未授權狀態!');
			this.router.navigate(['/login']);
		}
	}

	onSort({column, direction}: SortEvent) {
		// resetting other headers
		this.headers.forEach(header => {
			if (header.sortable !== column) {
				header.direction = '';
			}
		});

		this.purchaseService.sortColumn = column;
		this.purchaseService.sortDirection = direction;
	}

	// 產生一筆新的採購項目
	private purchaseBodyForm(_serial, _billCode): FormGroup {
		return new FormGroup({
			ERPCompID: new FormControl(''), // 隱藏參數
			Serial: new FormControl(_serial),
			PurchaseCode: new FormControl(_billCode),
			ItemCategoryID: new FormControl(null),
			ItemMaterialCode: new FormControl(null),
			ItemName: new FormControl(''),
			ItemSpec: new FormControl(''),
			ItemUnitCode: new FormControl(0),
			ItemUnitName: new FormControl(''),
			ItemCurrency: new FormControl(''),
			ItemQuantity: new FormControl(0),
			ItemPrice: new FormControl(0),
			ItemMemo: new FormControl(''),
			ItemTotal: new FormControl(0),
			ItemAcceptQuantity: new FormControl(0)
		});
	}

	// 產生已建立的品項資料
	private purchaseDetailForm(_purchase, _index): FormGroup {
		return new FormGroup({
			ERPCompID: new FormControl(_purchase.ERPCompID),
			Serial: new FormControl(_purchase.purchase_bill_data[_index]['Serial']),
			PurchaseCode: new FormControl(_purchase.purchase_bill_data[_index]['PurchaseCode']),
			ItemCategoryID: new FormControl(_purchase.purchase_bill_data[_index]['ItemCategoryID']),
			ItemMaterialCode: new FormControl(_purchase.purchase_bill_data[_index]['ItemMaterialCode']),
			ItemName: new FormControl(_purchase.purchase_bill_data[_index]['ItemName']),
			ItemSpec: new FormControl(_purchase.purchase_bill_data[_index]['ItemSpec']),
			ItemUnitCode: new FormControl(_purchase.purchase_bill_data[_index]['ItemUnitCode']),
			ItemUnitName: new FormControl(_purchase.purchase_bill_data[_index]['ItemUnitName']),
			ItemCurrency: new FormControl(_purchase.purchase_bill_data[_index]['ItemUnitCurrency']),
			ItemQuantity: new FormControl(
				_purchase.purchase_bill_data[_index]['ItemQuantity'],
				[
					Validators.min(_purchase.purchase_bill_data[_index]['ItemAcceptQuantity'])
				],
			),
			ItemMemo: new FormControl(
				this.activeProducts$.filter(x => x.ItemMaterialCode == _purchase.purchase_bill_data[_index]['ItemMaterialCode'])[0]['Memo']
			),
			ItemPrice: new FormControl(_purchase.purchase_bill_data[_index]['ItemPrice']),
			ItemTotal: new FormControl(_purchase.purchase_bill_data[_index]['ItemTotal']),
			ItemAcceptQuantity: new FormControl(_purchase.purchase_bill_data[_index]['ItemAcceptQuantity'])
		});
	}

	// 前往新增採購單據頁面
	goToNewPurchasePage() {
		let _isAccessAble = this.checkFuncAccessAble();
		if (!_isAccessAble) { return;}
		this.loadingService.startLoading('讀取資料');
		this.IsBrowsing = false;
		this.IsCreate = true;
		this.IsDetail = false;
		this.IsEdit = false;
		// 組成今日日期字串
		let _year = new Date().getFullYear();
		let _month = new Date().getMonth() + 1;
		let _date = new Date().getDate();
		let _todayDateStr = _year + "-" + _month + "-" + _date;
		// 重置品項陣列
		while ((this.purchaseForm.get('PurchaseItems') as FormArray).length) {
			(this.purchaseForm.get('PurchaseItems') as FormArray).removeAt(0);
		}
		this.addNewProductItem();
		// 初始化編輯器可進行修改
		this.editorConfig.editable = true;
		// 呼叫Server產生新的採購單編號
		let _currentCompInfo = JSON.parse(localStorage.getItem('currentERPComp'));
		if (_currentCompInfo != null) {
			let _erpCompid = _currentCompInfo.ERPCompID;
			this.purchaseService.generatePurchaseCode(_erpCompid, _todayDateStr).subscribe(response => {
				if (response.IsSuccess) {
					this.purchaseForm.patchValue({
						ERPCompID: _erpCompid,
						BillDate: { "year": _year, "month": _month, "day": _date},
						PlanDate: { "year": _year, "month": _month, "day": _date},
						AccDate: { year: this._year, month: this._month },
						Memo: '<p><br /></p>',
						BillCode: response.BillCode,
						BillType: 2,
						BillProviderID: '',
						BillProviderName: '',
						BillProviderCode: '',
						BillProviderAddress: '',
						BillProviderPhoneNum: '',
						BillProviderFaxNum: '',
						DeliverCityCode: '',
						DeliverCityName: '',
						DeliverZipCode: '',
						DeliverZipName: '',
						DeliverAddress: '',
						CurrencyCode: '1',
						PriceOfTax: 1, // 控制產品單價裡面有沒有含稅
						Total: 0,
						TaxFee: 0,
						TaxState: '1', // 1: 免稅, 2: 應稅, 3: 零稅
						PurchaseItems: [],
						ReceiverArray: [],
						ReceiverNameArray: [],
						DiscID: null
					});	
					this.loadingService.stopLoading();
				}
				else {
					this.loadingService.stopLoading();
					this.router.navigate(['/purchase']);
				}
			});
		}
		else {
			this.loadingService.stopLoading();
			this.router.navigate(['/login']);
		}
		// 檢查是否需要建立採購標籤
		this.IsNeedCreateSubjTag(0, '採購');
	}

	// 判斷是否需要建立採購標籤
	IsNeedCreateSubjTag(_tagType, _tagName) {
		let _currentCompInfo = JSON.parse(localStorage.getItem('currentERPComp'));
		let _currentUserInfo = JSON.parse(localStorage.getItem('currentERPUser'));
		let _userInfo = JSON.parse(localStorage.getItem('userInfo'));
		let _token = localStorage.getItem('Token');
		if (_currentCompInfo != null && _currentUserInfo != null && _userInfo != null && _token != null) {
			this.purchaseService.checkSubjTagIsExist(
				_currentCompInfo['SuccCompID'],
				_currentUserInfo['SuccUserID'],
				_userInfo[0]['LastName'] + _userInfo[0]['FirstName'],
				_tagType,
				_tagName,
				_token
			).subscribe(response => {
				if (_tagType == 0) {
					// 事件標籤
					this.purchaseForm.patchValue({
						SubjTagID: response.result
					});
				}
				else {
					// 對象標籤
					this.purchaseForm.patchValue({
						CusTagID: response.result
					});
				}
			});
		}
	}

	// 取消新增採購單
	backToBrowsePage() {
		this.IsBrowsing = true;
		this.IsCreate = false;
		this.IsDetail = false;
		this.IsEdit = false;
	}

	// 透過 providerID 產生 供應商/客戶 名稱
	generateProviderName(_providerID) {
		let _providerName = this.provider$.filter(x => x.SupplierID == _providerID)[0]['SupplierName'];
		return _providerName;
	}

	// 透過 providerID 產生 供應商/客戶 實體資料
	generateProviderEntity(_providerID) {
		let _providerEntity = this.provider$.filter(x => x.SupplierID == _providerID)[0];
		return _providerEntity;
	}

	// 產生單據日期字串
	generateBillDate(_billDate) {
		return _billDate.substring(0, 10);
	}

	// 供應商值發生變化
	onProviderChange(_target, _type) {
		console.log(_target);
		if (_target == undefined) {
			this.purchaseForm.patchValue({
				BillProviderID: '',
				BillProviderName: '',
				BillProviderCode: '',
				BillProviderAddress: '',
				BillProviderPhoneNum: '',
				BillProviderFaxNum: ''
			});			
		}
		else {
			this.purchaseForm.patchValue({
				BillProviderID: _target['SupplierID'],
				BillProviderName: _target['SupplierName'],
				BillProviderCode: _target['SupplierCode'],
				BillProviderAddress: _target['SupplierZipCode'] + _target['SupplierCityName'] + _target['SupplierZipName'] + _target['SupplierAddress'],
				BillProviderPhoneNum: _target['SupplierPhoneNum'],
				BillProviderFaxNum: _target['SupplierFaxNum'],
			});
			// 檢查是否需要建立供應商標籤 並指派
			this.IsNeedCreateSubjTag(1, _target['SupplierName']);
		}
	}

	// 稅別種類發生變化
	onTaxStateChange(_target, _type) {
		console.log(_target);
		console.log(_type);
	}

	// 產品是否含稅值 發生變化
	onPriceOfTaxChange(_target, _type) {
		console.log(_target);
		console.log(_type);
	}

	// 幣別發生變化
	onCurrencyChange(_target, _type) {
		console.log(_target);
		console.log(_type);
	}

	// 討論組選擇發生變化
	onDiscChange(_target) {
		let _currentCompInfo = JSON.parse(localStorage.getItem('currentERPComp'));
		let _currentUserInfo = JSON.parse(localStorage.getItem('currentERPUser'));
		let _token = localStorage.getItem('Token');
		console.log(_target);
		// 取得討論組收件人
		this.purchaseService.initNewMsgReceiver(
			_currentCompInfo['SuccCompID'],
			_target.DiscID,
			_currentUserInfo['SuccUserID'],
			_token
		).subscribe(response => {
			console.log("Disc : ", response);
			let _activeReceiver = response.data.filter(x => x.relate_comp_user != null);
			let _fixReceiverArray = [];
			let _receiverNameArray = [];
			_activeReceiver.filter(x => x.DefaultReceiver == 1).forEach(function(_item) {
				_fixReceiverArray.push(_item.UserID);
				_receiverNameArray.push({
					'UserName': _item.relate_comp_user.LastName + _item.relate_comp_user.FirstName
				});
			});
			// 如果當中不包含建立者本人
			if (_fixReceiverArray.filter(x => x == _currentUserInfo['SuccUserID']).length < 1) {
				_fixReceiverArray.push(_currentUserInfo['SuccUserID']);
				_receiverNameArray.push({
					'UserName': _currentUserInfo.UserName
				});
			}
			this.purchaseForm.patchValue({
				ReceiverArray: _fixReceiverArray,
				ReceiverNameArray: _receiverNameArray
			});
		});
	}

	cancelCreatePurchase() {
		this.IsBrowsing = true;
		this.IsCreate = false;
		this.IsDetail = false;
		this.IsEdit = false;
		this.IsEdit = false;
	}

	// 品項選擇發生變化
	onProductItemChange(_target, _index) {
		console.log(this.products$);
		console.log(_target);
		console.log(_index);
		if (_target == undefined) {
			this.purchaseForm.get('PurchaseItems')['controls'][_index].patchValue({
				ERPCompID: '',
				ItemCategoryID: '',
				PurchaseCode: '',
				ItemName: '',
				ItemSpec: '',
				ItemUnitCode: '',
				ItemUnitName: '',
				ItemCurrency: '',
				ItemMaterialCode: ''
			});			
		}
		else {
			// 使用者選擇的品項
			this.purchaseForm.get('PurchaseItems')['controls'][_index].patchValue({
				ERPCompID: this.purchaseForm.value['ERPCompID'],
				ItemCategoryID: _target['ItemCategoryID'],
				PurchaseCode: this.purchaseForm.value['BillCode'],
				ItemMaterialCode: _target['ItemMaterialCode'],
				ItemName: _target['ItemName'],
				ItemSpec: _target['ItemSpec'],
				ItemUnitCode: _target['ItemUnitCode'],
				ItemUnitName: _target['ItemUnitName'],
				ItemMemo: _target['Memo'],
				ItemCurrency: this.globalService.convertCurrencyShortID(this.purchaseForm.value['CurrencyCode'])
			});
		}
		console.log(this.purchaseForm.value);
	}

	// 客製化品項搜尋功能
	productSearchFn(term: string, productItem) {
		console.log(term);
		console.log(productItem);
		term = term.toLowerCase();
		return productItem.ItemMaterialCode.toLowerCase().indexOf(term) > -1 ||
			   productItem.ItemName.toLowerCase().indexOf(term) > -1 ||
			   productItem.ItemSpec.toLowerCase().indexOf(term) > -1;
	}

	// 客製化供應商搜尋功能
	supplierSearchFn(term: string, supplierItem) {
		term = term.toLowerCase();
		return supplierItem.SupplierCode.toLowerCase().indexOf(term) > -1 ||
			   supplierItem.SupplierName.toLowerCase().indexOf(term) > -1;
	}

	// 新增產品品項
	addNewProductItem() {
		(this.purchaseForm.get('PurchaseItems') as FormArray).push(this.purchaseBodyForm(
			this.purchaseForm.get('PurchaseItems')['length'] + 1,
			this.purchaseForm.value['BillCode']
		));
	}

	// 產品單價 or 產品數量異動 計算出品項小計
	UpdatePurchaseItem(_index) {
		// 參數宣告
		let result = 0; // 最後計算完小數點回傳的品項總金額
		let total = 0; // 未計算小數點前的品項總金額
		let total_length = 0;
		let dot_index = 0;
		let dot_last_index;

		let _price = (this.purchaseForm.get('PurchaseItems') as FormArray).at(_index).value['ItemPrice'];
		let _quantity = (this.purchaseForm.get('PurchaseItems') as FormArray).at(_index).value['ItemQuantity'];
		total = _quantity * _price;
		total_length = total.toString().length;
		dot_index = total.toString().indexOf(".");
		dot_last_index = total.toFixed(5).lastIndexOf('.')+5; // +5 用意是最小取至第五位進行四捨五入
		if (dot_index == -1) {
			result = parseFloat(total.toString());
		}
		else {
			result = parseFloat(total.toFixed(5).substring(0, dot_last_index));
		}
		// 塞入值
		this.purchaseForm.get('PurchaseItems')['controls'][_index].patchValue({
			ItemTotal: result
		});
	}

	// 編輯表單 產品單價 or 產品數量異動 計算出品項小計
	UpdateEditPurchaseItem(_index) {
		// 參數宣告
		let result = 0; // 最後計算完小數點回傳的品項總金額
		let total = 0; // 未計算小數點前的品項總金額
		let total_length = 0;
		let dot_index = 0;
		let dot_last_index;

		let _price = (this.detailForm.get('PurchaseItems') as FormArray).at(_index).value['ItemPrice'];
		let _quantity = (this.detailForm.get('PurchaseItems') as FormArray).at(_index).value['ItemQuantity'];
		if (_price < 0) {
			this.detailForm.get('PurchaseItems')['controls'][_index].patchValue({
				ItemPrice: 0
			});
			return;
		}
		if (_quantity < 0) {
			this.detailForm.get('PurchaseItems')['controls'][_index].patchValue({
				ItemQuantity: 0
			});
			return;
		}
		let _acceptedQuantity = (this.detailForm.get('PurchaseItems') as FormArray).at(_index).value['ItemAcceptQuantity'];
		total = _quantity * _price;
		total_length = total.toString().length;
		dot_index = total.toString().indexOf(".");
		dot_last_index = total.toFixed(5).lastIndexOf('.')+5; // +5 用意是最小取至第五位進行四捨五入
		if (dot_index == -1) {
			result = parseFloat(total.toString());
		}
		else {
			result = parseFloat(total.toFixed(5).substring(0, dot_last_index));
		}
		// 塞入值
		this.detailForm.get('PurchaseItems')['controls'][_index].patchValue({
			ItemTotal: result
		});
	}

	// 計算品項金額小數點後第一位 是不是都是5
	calculateTotalPointIsFive(_type) {
		// _type = 0: 新增狀態, _type = 1: 編輯狀態
		let result = true;
		if (_type == 0) {
			let _itemLength = (this.purchaseForm.get('PurchaseItems') as FormArray).length;
			for (var i = 0; i < _itemLength; i++) {
				let _isFiveIndex = (this.purchaseForm.get('PurchaseItems') as FormArray).at(i).value['ItemTotal'].toString().indexOf(".5");
				if (_isFiveIndex == -1) {
					result = false;
					return result;
				}
			}
		}
		else {
			let _itemLength = (this.detailForm.get('PurchaseItems') as FormArray).length;
			for (var i = 0; i < _itemLength; i++) {
				let _isFiveIndex = (this.detailForm.get('PurchaseItems') as FormArray).at(i).value['ItemTotal'].toString().indexOf(".5");
				if (_isFiveIndex == -1) {
					result = false;
					return result;
				}
			}
		}
		return result;
	}

	// 計算品項總數量
	calculateTotalAmount(_type) {
		// _type = 0: 新增狀態, _type = 1: 編輯狀態
		let result = 0;
		if (_type == 0) {
			let _itemLength = (this.purchaseForm.get('PurchaseItems') as FormArray).length;
			for (var i = 0; i < _itemLength; i++) {
				result += (this.purchaseForm.get('PurchaseItems') as FormArray).at(i).value['ItemQuantity'];
			}
		}
		else {
			let _itemLength = (this.detailForm.get('PurchaseItems') as FormArray).length;
			for (var i = 0; i < _itemLength; i++) {
				result += (this.detailForm.get('PurchaseItems') as FormArray).at(i).value['ItemQuantity'];
			}
		}
		return result;
	}

	// 轉Item Array 的方法，後續完整後要轉到Action裡面 For PDF
	// _type 0: 建立, 1: 編輯
	GeneratePurchaseItemArray(_itemLength, _type) {
		let result = [];
		if (_type == 0) {
			for (var i = 0; i < _itemLength; i++) {
				result.push({
					'Serial': (this.purchaseForm.get('PurchaseItems') as FormArray).at(i).value['Serial'].toString(),
					'ItemID': (this.purchaseForm.get('PurchaseItems') as FormArray).at(i).value['ItemMaterialCode'],
					'ItemName': (this.purchaseForm.get('PurchaseItems') as FormArray).at(i).value['ItemName'],
					'ItemAmount': (this.purchaseForm.get('PurchaseItems') as FormArray).at(i).value['ItemQuantity'],
					'ItemUnit': (this.purchaseForm.get('PurchaseItems') as FormArray).at(i).value['ItemUnitName'],
					'ItemPrice': (this.purchaseForm.get('PurchaseItems') as FormArray).at(i).value['ItemPrice'],
					'ItemTotal': (this.purchaseForm.get('PurchaseItems') as FormArray).at(i).value['ItemTotal'],
					'PreDeliverDate': ""
				});
			}
		}
		else {
			for (var i = 0; i < _itemLength; i++) {
				result.push({
					'Serial': (this.detailForm.get('PurchaseItems') as FormArray).at(i).value['Serial'].toString(),
					'ItemID': (this.detailForm.get('PurchaseItems') as FormArray).at(i).value['ItemMaterialCode'],
					'ItemName': (this.detailForm.get('PurchaseItems') as FormArray).at(i).value['ItemName'],
					'ItemAmount': (this.detailForm.get('PurchaseItems') as FormArray).at(i).value['ItemQuantity'],
					'ItemUnit': (this.detailForm.get('PurchaseItems') as FormArray).at(i).value['ItemUnitName'],
					'ItemPrice': (this.detailForm.get('PurchaseItems') as FormArray).at(i).value['ItemPrice'],
					'ItemTotal': (this.detailForm.get('PurchaseItems') as FormArray).at(i).value['ItemTotal'],
					'PreDeliverDate': ""
				});
			}
		}
		return result;
	}

	// 產生SuccMail發布主題要用的Content
	generateSubjContent(_priceInfo, _type) {
		let FormEntity = null;
		if (_type == 0) {
			// 建立採購單
			FormEntity = this.purchaseForm;
		}
		else {
			// 編輯採購單
			FormEntity = this.detailForm;
		}

		let ContentString = "";

		let customerIDLabel = "廠商編號：";
		let purchseCodeLabel = "採購單號：";
    	let customerNameLabel = "廠商名稱：";
    	let addressLabel = "廠商地址：";
    	let phoneLabel = "連絡電話：";
    	let faxLabel = "傳真號碼：";
    	let linkManLabel = "聯絡人員：";
    	let taxCodeLabel = "稅別種類：";
    	let currencyIDLabel = "幣　　別：";
    	let currencyRateLabel = "匯　　率：";
    	let itemIncludeTaxLabel = "產品單價：";
    	let planDateLabel = "預進日期：";
    	let accDateLabel = "帳款日期：";

    	let serialLabel = "序　　號：";
    	let selectedWHLabel = "預計入庫：";
    	let itemCodeLabel = "產品編號：";
    	let itemNameLabel = "品名規格：";
    	let itemNumberLabel = "採購數量：";
    	let itemUnitLabel = "品項單位：";
    	let itemPriceLabel = "單　　價：";
    	let deliverDateLabel = "預進日期：";
    	let itemMemoLabel = "品項備註：";
    	let eachPriceLabel = "金　　額：";
    	let memoLabel = "單據備註：";

    	let orderPriceLabel = "原幣合計：";
    	let taxPriceLabel = "原幣稅金：";
    	let totalPriceLabel = "原幣總計：";

    	let emptyRow = "<p><br /></p>";
    	let seperateRow = "<p>------------------------------ 分隔線 ------------------------------</p>";
    	// 原幣
    	let _currencyID = this.globalService.convertCurrencyShortID(FormEntity.value['CurrencyCode']);
    	let _currencyName = this.globalService.convertCurrencyName(FormEntity.value['CurrencyCode']);
    	
    	let orderPriceRow = "<p>" + orderPriceLabel + _priceInfo.NoTaxTotal + " " + _currencyID + "</p>";
    	let taxFeeRow = "<p>" + taxPriceLabel + _priceInfo.TaxFee + " " + _currencyID + "</p>";
    	let withTaxTotalRow = "<p>" + totalPriceLabel + _priceInfo.WithTaxTotal + " " + _currencyID + "</p>";

    	// 統一內容區域
    	let custIDRow = "<p>" + customerIDLabel + FormEntity.value['BillProviderCode'] + "</p>";
    	let purchaseCodeRow = "<p>" + purchseCodeLabel + FormEntity.value['BillCode'] + "</p>";
    	let custNameRow = "<p>" + customerNameLabel + FormEntity.value['BillProviderName'] + "</p>";
    	let addressRow = "<p>" + addressLabel + FormEntity.value['BillProviderAddress'] + "</p>";
    	let phoneRow = "<p>" + phoneLabel + FormEntity.value['BillProviderPhoneNum'] + "</p>";
    	let faxRow = "<p>" + faxLabel + FormEntity.value['BillProviderFaxNum'] + "</p>";
    	// let linkManRow = "<p>" + linkManLabel + this.props.CustomerDetail.get("LinkMan") + "</p>";
    	let taxRow = "<p>" + taxCodeLabel + this.globalService.convertTaxState(FormEntity.value['TaxState'].toString());
    	let currencyIDRow = "<p>" + currencyIDLabel + _currencyID + " " + _currencyName + "</p>";
    	let currencyRateRow = "<p>" + currencyRateLabel + 1 + "</p>";
    	// 產品品項是否含稅
    	let itemIncludeTaxVal = FormEntity.value['PriceOfTax'] == 0 ? "未稅":"含稅";
    	let itemIncludeTaxRow = "<p>" + itemIncludeTaxLabel + itemIncludeTaxVal + "</p>";
    	let planDateStr = "";
    	let accDateStr = "";
    	let memoStr = "";

    	if (_type == 0) {
    		planDateStr = FormEntity.value['PlanDate']['year']+"/"+FormEntity.value['PlanDate']['month']+"/"+FormEntity.value['PlanDate']['day'];
    		accDateStr = FormEntity.value['AccDate']['year']+"/"+FormEntity.value['AccDate']['month'];
    		memoStr = FormEntity.value['Memo'];
    	}
    	else {
    		planDateStr = FormEntity.value['PlanDate'];
    		accDateStr = FormEntity.value['AccDate'];
    	}
    	
    	let planDateLabelRow = "<p>" + planDateLabel + planDateStr + "</p>";
    	let accDateLabelRow = "<p>" + accDateLabel + accDateStr + "</p>";
    	let memoLabelRow = "<p>" + memoLabel + memoStr + "</p>";

    	// 統一訊息部分
    	ContentString += custIDRow + purchaseCodeRow + custNameRow + addressRow + phoneRow + faxRow + taxRow + currencyIDRow + currencyRateRow + itemIncludeTaxRow + planDateLabelRow + accDateLabelRow + emptyRow + memoLabelRow + emptyRow;

    	// 個別品項訊息部分
		let _itemLength = (FormEntity.get('PurchaseItems') as FormArray).length;
		for (var i = 0; i < _itemLength; i++) {
    		let SerialRow = "<p>" + serialLabel + (i + 1) + "</p>";
    		let ItemCodeRow = "<p>" + itemCodeLabel + (FormEntity.get('PurchaseItems') as FormArray).at(i).value['ItemMaterialCode'] + "</p>";
    		let ItemNameRow = "<p>" + itemNameLabel + (FormEntity.get('PurchaseItems') as FormArray).at(i).value['ItemName'] + (FormEntity.get('PurchaseItems') as FormArray).at(i).value['ItemSpec'] + "</p>";
    		let ItemQuantityRow = "<p>" + itemNumberLabel + (FormEntity.get('PurchaseItems') as FormArray).at(i).value['ItemQuantity'] + "</p>";
    		let ItemUnitRow = "<p>" + itemUnitLabel + (FormEntity.get('PurchaseItems') as FormArray).at(i).value['ItemUnitName'] + "</p>";
    		let ItemMemoRow = "<p>" + itemMemoLabel + (FormEntity.get('PurchaseItems') as FormArray).at(i).value['ItemMemo'] + "</p>";
    		let ItemPriceRow = "<p>" + itemPriceLabel + (FormEntity.get('PurchaseItems') as FormArray).at(i).value['ItemPrice'] + " " + _currencyID + "</p>";
    		let EachItemTotalRow = "<p>" + eachPriceLabel + (FormEntity.get('PurchaseItems') as FormArray).at(i).value['ItemTotal'] + " " + _currencyID + "</p>";
    		ContentString += SerialRow + ItemCodeRow + ItemNameRow + ItemQuantityRow + ItemUnitRow + ItemPriceRow + ItemMemoRow + EachItemTotalRow + seperateRow; 
		}

    	// 金額訊息部分
    	ContentString += orderPriceRow + taxFeeRow + withTaxTotalRow;

    	return ContentString;
	}

	// 建立採購單到 Server
	onSubmitPurchase() {
		let _isAccessAble = this.checkFuncAccessAble();
		if (!_isAccessAble) { return;}
		this.loadingService.startLoading('建立採購單據中...');
		// 全域參數
		let _token = localStorage.getItem("Token");
		let _currentCompInfo = JSON.parse(localStorage.getItem('currentERPComp'));
		let _currentUserInfo = JSON.parse(localStorage.getItem('currentERPUser'));
		let _erpCompid = _currentCompInfo.ERPCompID;
		let _erpUserName = _currentUserInfo.UserName;
		let _erpUserid = _currentUserInfo.ERPUserID;

		// 取得判斷所有計算出的品項金額 小數點後第一位 是不是都是5 
		// 如果 true: 計算應稅外加時，稅額不進位只取到整數位
		// 如果 false: 計算應稅外加時，稅額從小數點後面逐個進位
		let _isFiveAtFirstPoint = this.calculateTotalPointIsFive(0);
		console.log(_isFiveAtFirstPoint);
		// 總數量
		let _totalQuantity = this.calculateTotalAmount(0);
		console.log(_totalQuantity);
		// 品項數量
		let _itemLength = (this.purchaseForm.get('PurchaseItems') as FormArray).length;
		// 錢相關
		let _total = 0;
		for (var i = 0; i < _itemLength; i++) {
			_total += (this.purchaseForm.get('PurchaseItems') as FormArray).at(i).value['ItemTotal'];
		}

		let _priceInfo = this.globalService.calculateTotalAndTaxFee(
			_isFiveAtFirstPoint,
			_itemLength,
			_total,
			this.purchaseForm.value['PriceOfTax'],
			this.purchaseForm.value['TaxState']
		);
		console.log(_priceInfo);
		let _taxFee = _priceInfo.TaxFee;
		let _noTaxTotal = _priceInfo.NoTaxTotal;
		let _withTaxTotal = _priceInfo.WithTaxTotal;
		// 表頭參數
		let _billDate = this.purchaseForm.value['BillDate']['year']+"/"+this.purchaseForm.value['BillDate']['month']+"/"+this.purchaseForm.value['BillDate']['day'];
		let _planDate = this.purchaseForm.value['PlanDate']['year']+"/"+this.purchaseForm.value['PlanDate']['month']+"/"+this.purchaseForm.value['PlanDate']['day'];
		let _accDate = this.purchaseForm.value['AccDate']['year']+"/"+parseInt(this.purchaseForm.value['AccDate']['month'])+"/"+"01";

		// 準備要使用的列印PDF的參數
		let _paramObjForCreatePDF = {
			ERPCompName: _currentCompInfo.CompName,
			ERPCompAreaCode: '',
			ERPCompAddress: _currentCompInfo.CompAddress,
			ERPCompPhone: _currentCompInfo.CompPhoneNum,
			ERPCompFax: _currentCompInfo.CompFaxNum,
			WesternTodayDate: this.globalService.convertWesternDateStr(new Date(),"/"),
			WesternPurchaseDate: _billDate,
			PlanDate: _planDate,
			AccDate: this.purchaseForm.value['AccDate']['year']+"/"+this.purchaseForm.value['AccDate']['month'],
			SupplierID: this.purchaseForm.value['BillProviderCode'],
			SupplierCompName: this.purchaseForm.value['BillProviderName'],
			SupplierAddress: this.purchaseForm.value['BillProviderAddress'],
			SupplierPhoneNum: this.purchaseForm.value['BillProviderPhoneNum'],
			SupplierFaxNum: this.purchaseForm.value['BillProviderFaxNum'],
			LinkMan: '',
			CurrencyID: this.purchaseForm.value['CurrencyCode'],
			CurrencyName: this.globalService.convertCurrencyShortID(this.purchaseForm.value['CurrencyCode']),
			CurrencyRate: 1,
			SalesManID: '',
			SalesManName: _erpUserName,
			CreatorName: _erpUserName,
			Memo: encodeURIComponent(this.purchaseForm.value['Memo']),
			DepartmentID: '',
			DepartmentName: '',
			BillNo: this.purchaseForm.value['BillCode'],
			ItemTaxState: this.purchaseForm.value['PriceOfTax'] == 0 ? "未稅":"含稅",
			TotalItemCount: _itemLength,
			TotalItemAmount: _totalQuantity,
			NoTaxTotal: _priceInfo.NoTaxTotal,
			TaxFee: _priceInfo.TaxFee,
			WithTaxTotal: _priceInfo.WithTaxTotal,
			PurchaseSheetItem: this.GeneratePurchaseItemArray(_itemLength, 0),
			FooterTerms: '',
			CreatorCompID: _currentCompInfo.SuccCompID
		};
		// 建立採購單物件
		let _purchaseBill = {
			ERPCompID: _erpCompid,
			BillDate: _billDate,
			PlanDate: _planDate,
			AccDate: _accDate,
			Memo: this.purchaseForm.value['Memo'],
			BillCode: this.purchaseForm.value['BillCode'],
			BillType: this.purchaseForm.value['BillType'],
			OperatorID: _erpUserid,
			BillProviderID: this.purchaseForm.value['BillProviderID'],
			DeliverCityCode: '',
			DeliverCityName: '',
			DeliverZipCode: '',
			DeliverZipName: '',
			DeliverAddress: '',
			CurrencyCode: this.purchaseForm.value['CurrencyCode'],
			PriceOfTax: this.purchaseForm.value['PriceOfTax'],
			Total: _priceInfo.NoTaxTotal,
			TaxFee: _priceInfo.TaxFee,
			TaxState: this.purchaseForm.value['TaxState'],
			BillState: 0,
			BillBody: JSON.stringify(this.purchaseForm.value['PurchaseItems']),
			LogUserDevice: this.globalService.detectUserAgent()
		};
		// 送到SuccMail的物件
		let _subjTitle = this.globalService.generateSubjTitle(_itemLength, (this.purchaseForm.get('PurchaseItems') as FormArray));
		var subjFormData = new FormData();
		subjFormData.append("token", _token);
		subjFormData.append("CompID", _currentCompInfo.SuccCompID);
		subjFormData.append("DiscID", this.purchaseForm.value['DiscID']);
		subjFormData.append("UserID", _currentUserInfo.SuccUserID);
		subjFormData.append("Title", _subjTitle);
		subjFormData.append("sContent", this.generateSubjContent(_priceInfo, 0));
		subjFormData.append("PlanCloseOn", null);
		subjFormData.append("Receiver", JSON.stringify(this.purchaseForm.value['ReceiverArray']));
		subjFormData.append("EventTagID", this.purchaseForm.value['SubjTagID']);
		subjFormData.append("CusTagID", this.purchaseForm.value['CusTagID']);
		subjFormData.append("ByUserDevice", this.globalService.detectUserDevice());
		subjFormData.append("ByUserBrowser", this.globalService.detectUserAgent());
		subjFormData.append("DetailSubjTitle", "採購 - " + this.purchaseForm.value['BillProviderName'] + " - " + _subjTitle + " - " + this.globalService.convertWesternDateStr(new Date(),"/"));
		subjFormData.append("SubjRead", JSON.stringify(this.purchaseForm.value['ReceiverNameArray']));
		subjFormData.append("DiscType", '2');
		subjFormData.append("AdminData", JSON.stringify([]));
		subjFormData.append("SubjType", '3001'); // 2001: 正航採購, 2003: 正航訂單, 3001: Succ採購, 3002: Succ入庫, 3003: Succ訂單, 3004: Succ銷貨

		console.log(this.purchaseForm.value['SubjTagID']);
		console.log(this.purchaseForm.value['CusTagID']);
		
		// 準備存放上傳完成的檔案
		let AttList = [];
		this.purchaseService.generatePurchasePDF(_paramObjForCreatePDF).subscribe(pdfRes => {
			if (pdfRes.IsSuccess) {
				let _attID = pdfRes.AttID;
				let _filePath = pdfRes.FilePath;
				let _filSize = pdfRes.FileSize;
				let _fileSizeView = pdfRes.FileSizeView;
				let _fileExt = pdfRes.FileExt;
				AttList.push({
					'AttID': pdfRes.AttID,
					'FileName': _paramObjForCreatePDF.WesternTodayDate + "-" + _paramObjForCreatePDF.SupplierCompName + "-" + "採購單憑證.pdf",
					'FilePath': pdfRes.FilePath,
					'FileSize': pdfRes.FileSize,
					'FileSizeView': pdfRes.FileSizeView,
					'FileType': pdfRes.FileExt.toString().toUpperCase(),
					'IsDel': false,
					'IsEmbed': false,
					'IsSuccess': true,
					'uid': "rc-upload-1554787902309-2"
				});
				// 指派Succ建立主題物件的檔案資料
				subjFormData.append("AttList", JSON.stringify(AttList)); 
				// 建立採購單據
				this.purchaseService.insertPurchaseBill(_purchaseBill).subscribe(purchaseRes => {
					let _isCreatePurchaseSuccess = purchaseRes.IsSuccess;
					let _billCode = purchaseRes.BillCode; // 進server有再判斷一次這個billCode有無重複
					subjFormData.append("BillNo", _billCode);
					// 建立SuccMail主題
					this.purchaseService.createPurchaseSuccSubj(subjFormData).subscribe(succRes => {
						console.log(succRes);
						if (succRes.result) {
							// 把SubjID 寫入這一筆採購訂單
							this.purchaseService.updatePurchaseRealtedSubjID({
								ERPCompID: _erpCompid,
								BillType: 2,
								BillCode: this.purchaseForm.value['BillCode'],
								SubjID: succRes.SubjID
							}).subscribe(updateRes => {
								console.log(updateRes);
								this.loadingService.stopLoading();
								window.scrollTo(0, 0);
								this.globalService.changeRemindState('open');
								this.globalService.changeRemindType(0);
								this.globalService.changeRemindMsg('資料修改成功!');
								this.purchaseService.refreshDataList();
								this.IsBrowsing = true;
								this.IsCreate = false;
								this.IsDetail = false;
								this.IsEdit = false;
							});
						}
						else {
							this.globalService.changeRemindState('open');
							this.globalService.changeRemindType(1);
							this.globalService.changeRemindMsg('資料修改錯誤!');
							this.router.navigate(['/']);
						}
					});
				});
			}
		});
	}
	
	// 轉換CurrencyCode to Name
	generateCurrencyName(_currenctCode) {
		return this.globalService.convertCurrencyName(_currenctCode);
	}

	// 轉換CurrencyCode to ShortID
	generateCurrencyShortID(_currencyCode) {
		return this.globalService.convertCurrencyShortID(_currencyCode);
	}

	// 查看詳細資料
	checkDetail(_purchase) {
		console.log("purchase : ");
		console.log(_purchase);
		window.scrollTo(0, 0);
		this.IsBrowsing = false;
		this.IsCreate = false;
		this.IsDetail = true;
		this.IsEdit = false;
		// 編輯器不可編輯
		this.editorConfig.editable = false;
		// 將值塞入 detailForm
		let _provider = this.generateProviderEntity(_purchase.BillProviderID);
		this.detailForm.patchValue({
			ERPCompID: _purchase.ERPCompID,
			BillState: _purchase.BillState,
			BillDate: _purchase.BillDate.substring(0, 10),
			PlanDate: _purchase.PlanDate == null ? "" : _purchase.PlanDate.substring(0, 10),
			AccDate: _purchase.AccDate == null ? "" : _purchase.AccDate.substring(0, 7),
			Memo: _purchase.Memo.length > 0 ? _purchase.Memo:"<p><br /></p>",
			BillCode: _purchase.BillCode,
			BillType: 2,
			BillProviderID: _purchase.BillProviderID,
			BillProviderName: this.generateProviderName(_purchase.BillProviderID),
			BillProviderCode: _provider['SupplierCode'],
			BillProviderAddress: _provider['SupplierZipCode'] + _provider['SupplierCityName'] + _provider['SupplierZipName'] + _provider['SupplierAddress'],
			BillProviderPhoneNum: _provider['SupplierPhoneNum'],
			BillProviderFaxNum: _provider['SupplierFaxNum'],
			CurrencyCode: _purchase['CurrencyCode'],
			PriceOfTax: _purchase['PriceOfTax'],
			PriceOfTaxStr: _purchase['PriceOfTax'] == 0 ? "未稅":"含稅",
			Total: _purchase['Total'],
			TaxFee: _purchase['TaxFee'],
			TaxState: _purchase['TaxState'],
			TaxStateStr: this.globalService.convertTaxState(_purchase['TaxState'].toString()),
			SubjID: _purchase['SuccSubjID']
		});
		// 重置品項陣列
		while ((this.detailForm.get('PurchaseItems') as FormArray).length) {
			(this.detailForm.get('PurchaseItems') as FormArray).removeAt(0);
		}
		console.log(this.activeProducts$);
		// 塞入品項
		for (var i = 0; i< _purchase.purchase_bill_data.length; i++) {
			(this.detailForm.get('PurchaseItems') as FormArray).push(
				this.purchaseDetailForm(_purchase, i)
			);
		}
	}

	// 轉入庫單
	ConvertToStockInSheet(_billCode) {
		console.log(_billCode);
		this.router.navigate(['/stockIn/' + _billCode]);
	}

	// HTTP Request 失敗狀態
	failHttpRequest(_msgState, _remindType, _remindMsg) {
		// remindType 0: Success, 1: Fail
		this.loadingService.stopLoading();
		window.scrollTo(0, 0);
		this.globalService.changeRemindState(_msgState);
		this.globalService.changeRemindType(_remindType);
		this.globalService.changeRemindMsg(_remindMsg);
	}

	// 回到選單頁面
	goToMenuPage() {
		this.router.navigate(['/home']);
	}

	// 確認權限是否符合進入函式
	checkFuncAccessAble() {
		let _isDisableAccess = this.checkIsDisAbleToModify();
		if (_isDisableAccess) {
			this.globalService.changeRemindState('open');
			this.globalService.changeRemindType(1);
			this.globalService.changeRemindMsg('權限授予失敗!');
			return false;
		}
		else {
			return true;
		}
	}

	// 只有權限 = 101, 102, 104 可以看到更新按鈕 並且修改內容
	checkIsDisAbleToModify() {
		switch (this.userPower) {
			case 101:
			case 102:
			case 104:
				return false;
				break;
			case 103:
				return true;
			default:
				return true;
				break;
		}
	}

	// 只有權限 101, 104 才能進行作廢
	chekcIsDisAbleToDestroy() {
		switch (this.userPower) {
			case 101:
			case 104:
				return false;
				break;
			case 102:
			case 103:
				return true;
			default:
				return true;
				break;
		}
	}

	// 作廢採購單
	returnPurchaseBill() {
		this.loadingService.startLoading("採購單作廢中...");
		let _currentUserInfo = JSON.parse(localStorage.getItem('currentERPUser'));
		// _erpCompid, _billCode, _inventoryType, _inventoryTypeName, _operatorid, _loguserDeivce
		this.purchaseService.returnPurchase(
			this.detailForm.value['ERPCompID'],
			this.detailForm.value['BillCode'],
			203,
			'採購作廢',
			_currentUserInfo.ERPUserID,
			this.globalService.detectUserAgent()
		).subscribe(response => {
			if (response.IsSuccess) {
				this.globalService.changeRemindState('open');
				this.globalService.changeRemindType(0);
				this.globalService.changeRemindMsg('成功作廢採購單據!');
				this.purchaseService.refreshDataList();
				this.IsBrowsing = true;
				this.IsCreate = false;
				this.IsDetail = false;
				this.IsEdit = false;
			}
			else {
				this.globalService.changeRemindState('open');
				this.globalService.changeRemindType(1);
				this.globalService.changeRemindMsg(response.message);
			}
			window.scrollTo(0, 0);
			this.loadingService.stopLoading();
		});
	}

	// 採購日期發生變化
	billDateChange($event) {
		this.loadingService.startLoading('重新產生採購編號...');
		let _currentDateString = $event.year + "-" + $event.month + "-" + $event.day;
		let _currentCompInfo = JSON.parse(localStorage.getItem('currentERPComp'));
		if (_currentCompInfo != null) {
			let _erpCompid = _currentCompInfo.ERPCompID;
			this.purchaseService.generatePurchaseCode(_erpCompid, _currentDateString).subscribe(response => {
				if (response.IsSuccess) {
					this.purchaseForm.patchValue({
						BillDate: { "year": $event.year, "month": $event.month, "day": $event.day},
						BillCode: response.BillCode,
					});
				}
				this.loadingService.stopLoading();
			});
		}
	}

	// 編輯採購單
	EditPurchaseBill() { 
		this.IsBrowsing = false;
		this.IsCreate = false;
		this.IsDetail = true;
		this.IsEdit = true;
	}

	// 採購單預計進貨日期發生變化
	planAcceptDateChange($event) {
		this.purchaseForm.patchValue({
			PlanDate: { "year": $event.year, "month": $event.month, "day": $event.day},
		});
	}

	// 移除產品品項
	removeProductItem(_index) {
		if ((this.purchaseForm.get('PurchaseItems') as FormArray).length < 2) {
			return;
		}
		else {
			(this.purchaseForm.get('PurchaseItems') as FormArray).removeAt(_index);
			for (var i = 0; i<(this.purchaseForm.get('PurchaseItems') as FormArray).length; i++) {
				this.purchaseForm.get('PurchaseItems')['controls'][i].patchValue({
					Serial: i+1
				});
			}
		}
	}

	// 進行採購單編輯
	SubmitEditPurchase(_billCode) {
		console.log(_billCode);
		let _isAccessAble = this.checkFuncAccessAble();
		if (!_isAccessAble) { return;}
		this.loadingService.startLoading('更新採購單據中...');
		// 全域參數
		let _token = localStorage.getItem("Token");
		let _currentCompInfo = JSON.parse(localStorage.getItem('currentERPComp'));
		let _currentUserInfo = JSON.parse(localStorage.getItem('currentERPUser'));
		let _erpCompid = _currentCompInfo.ERPCompID;
		let _erpUserName = _currentUserInfo.UserName;
		let _erpUserid = _currentUserInfo.ERPUserID;

		// 取得判斷所有計算出的品項金額 小數點後第一位 是不是都是5 
		// 如果 true: 計算應稅外加時，稅額不進位只取到整數位
		// 如果 false: 計算應稅外加時，稅額從小數點後面逐個進位
		let _isFiveAtFirstPoint = this.calculateTotalPointIsFive(1);
		console.log(_isFiveAtFirstPoint);
		// 總數量
		let _totalQuantity = this.calculateTotalAmount(1);
		console.log(_totalQuantity);
		// 品項數量
		let _itemLength = (this.detailForm.get('PurchaseItems') as FormArray).length;
		// 錢相關
		let _total = 0;
		for (var i = 0; i < _itemLength; i++) {
			_total += (this.detailForm.get('PurchaseItems') as FormArray).at(i).value['ItemTotal'];
		}

		let _priceInfo = this.globalService.calculateTotalAndTaxFee(
			_isFiveAtFirstPoint,
			_itemLength,
			_total,
			this.detailForm.value['PriceOfTax'],
			this.detailForm.value['TaxState']
		);
		console.log(_priceInfo);
		let _taxFee = _priceInfo.TaxFee;
		let _noTaxTotal = _priceInfo.NoTaxTotal;
		let _withTaxTotal = _priceInfo.WithTaxTotal;
		// 表頭參數
		let _billDate = this.detailForm.value['BillDate'];

		// 準備要使用的列印PDF的參數
		let _paramObjForCreatePDF = {
			ERPCompName: _currentCompInfo.CompName,
			ERPCompAreaCode: '',
			ERPCompAddress: _currentCompInfo.CompAddress,
			ERPCompPhone: _currentCompInfo.CompPhoneNum,
			ERPCompFax: _currentCompInfo.CompFaxNum,
			WesternTodayDate: this.globalService.convertWesternDateStr(new Date(),"/"),
			WesternPurchaseDate: _billDate.replace(/-/g,'/'),
			PlanDate: this.detailForm.value['PlanDate'],
			SupplierID: this.detailForm.value['BillProviderCode'],
			SupplierCompName: this.detailForm.value['BillProviderName'],
			SupplierAddress: this.detailForm.value['BillProviderAddress'],
			SupplierPhoneNum: this.detailForm.value['BillProviderPhoneNum'],
			SupplierFaxNum: this.detailForm.value['BillProviderFaxNum'],
			LinkMan: '',
			CurrencyID: this.detailForm.value['CurrencyCode'],
			CurrencyName: this.globalService.convertCurrencyShortID(this.detailForm.value['CurrencyCode']),
			CurrencyRate: 1,
			SalesManID: '',
			SalesManName: _erpUserName,
			CreatorName: _erpUserName,
			Memo: '',
			DepartmentID: '',
			DepartmentName: '',
			BillNo: this.detailForm.value['BillCode'],
			ItemTaxState: this.detailForm.value['PriceOfTax'] == 0 ? "未稅":"含稅",
			TotalItemCount: _itemLength,
			TotalItemAmount: _totalQuantity,
			NoTaxTotal: _priceInfo.NoTaxTotal,
			TaxFee: _priceInfo.TaxFee,
			WithTaxTotal: _priceInfo.WithTaxTotal,
			PurchaseSheetItem: this.GeneratePurchaseItemArray(_itemLength, 1),
			FooterTerms: '',
			CreatorCompID: _currentCompInfo.SuccCompID
		}
		// 更新採購單物件
		let _purchaseBill = {
			ERPCompID: _erpCompid,
			BillDate: _billDate.replace(/-/g,'/'),
			BillCode: this.detailForm.value['BillCode'],
			BillType: this.detailForm.value['BillType'],
			OperatorID: _erpUserid,
			Total: _priceInfo.NoTaxTotal,
			TaxFee: _priceInfo.TaxFee,
			BillBody: JSON.stringify(this.detailForm.value['PurchaseItems']),
			LogUserDevice: this.globalService.detectUserAgent()
		};
		// 送到SuccMail的物件
		let _subjTitle = this.globalService.generateSubjTitle(_itemLength, (this.detailForm.get('PurchaseItems') as FormArray));
		var subjFormData = new FormData();
		subjFormData.append("token", _token);
		subjFormData.append("CompID", _currentCompInfo.SuccCompID);
		subjFormData.append("UserID", _currentUserInfo.SuccUserID);
		subjFormData.append("Title", _subjTitle);
		subjFormData.append("sContent", this.generateSubjContent(_priceInfo, 1));
		subjFormData.append("PlanCloseOn", null);
		subjFormData.append("ByUserDevice", this.globalService.detectUserDevice());
		subjFormData.append("ByUserBrowser", this.globalService.detectUserAgent());
		subjFormData.append("DetailSubjTitle", "採購 - " + this.detailForm.value['BillProviderName'] + " - " + _subjTitle + " - " + this.globalService.convertWesternDateStr(new Date(),"/"));
		subjFormData.append("DiscType", '2');
		subjFormData.append("AdminData", JSON.stringify([]));
		subjFormData.append("SubjType", '3001'); // 2001: 正航採購, 2003: 正航訂單, 3001: Succ採購, 3002: Succ入庫, 3003: Succ訂單, 3004: Succ銷貨
		subjFormData.append("SubjID", this.detailForm.value['SubjID']);

		// 準備存放上傳完成的檔案
		let AttList = [];
		this.purchaseService.generatePurchasePDF(_paramObjForCreatePDF).subscribe(pdfRes => {

			if (pdfRes.IsSuccess) {
				let _attID = pdfRes.AttID;
				let _filePath = pdfRes.FilePath;
				let _filSize = pdfRes.FileSize;
				let _fileSizeView = pdfRes.FileSizeView;
				let _fileExt = pdfRes.FileExt;
				AttList.push({
					'AttID': pdfRes.AttID,
					'FileName': _paramObjForCreatePDF.WesternTodayDate + "-" + _paramObjForCreatePDF.SupplierCompName + "-" + "採購單憑證.pdf",
					'FilePath': pdfRes.FilePath,
					'FileSize': pdfRes.FileSize,
					'FileSizeView': pdfRes.FileSizeView,
					'FileType': pdfRes.FileExt.toString().toUpperCase(),
					'IsDel': false,
					'IsEmbed': false,
					'IsSuccess': true,
					'uid': "rc-upload-1554787902309-3"
				});
				// 指派Succ建立主題物件的檔案資料
				subjFormData.append("AttList", JSON.stringify(AttList)); 
				// 更新採購單據
				this.purchaseService.updatePurchaseBill(_purchaseBill).subscribe(purchaseRes => {
					let _billCode = purchaseRes.BillCode;
					subjFormData.append("BillNo", _billCode);
					// 更新SuccMail主題
					this.purchaseService.updatePurchaseSubj(subjFormData).subscribe(succRes => {
						if (succRes.result) {
							// 更新成功
							this.globalService.changeRemindState('open');
							this.globalService.changeRemindType(0);
							this.globalService.changeRemindMsg('成功修改採購單據!');
							this.purchaseService.refreshDataList();
							this.IsBrowsing = true;
							this.IsCreate = false;
							this.IsDetail = false;
							this.IsEdit = false;
						}
						else {
							// 更新失敗
							this.globalService.changeRemindState('open');
							this.globalService.changeRemindType(1);
							this.globalService.changeRemindMsg(succRes.message);
						}
						window.scrollTo(0, 0);
						this.loadingService.stopLoading();
					});
				});
			}
		});
	}
}
